import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import styled from 'styled-components';
import { GREY, TEXT } from '../Colors';
import { BODY, HEADING_03 } from '../Fonts';

const StyledDialog = styled(MuiDialog)`
    &>.MuiDialog-container>.MuiPaper-root {
        font: ${BODY};
        color: ${TEXT};
        background-color: ${GREY};
        display: flex;
        max-width: 100%;
        max-height: calc(100% - 64px);
        flex-direction: column;
        width: ${props => props.theme.width};
        height: ${props => props.theme.height};
        
        &>.MuiDialogTitle-root {
            padding: 12px;
            padding-bottom: 0;
            & .MuiTypography-root: {
                font: ${HEADING_03};
            }
        }

        &>.MuiDialogContent-root {
            padding: 12px;
            flex: 1;
        }

        &>.MuiDialogActions-root {
            padding: 8px;
            padding-top: 0;
        }
    }
`

interface DialogProps {
    width: string,
    height: string,
    onClose?(): void,
    title?: React.ReactNode,
    footerActions?: ReadonlyArray<React.ReactElement>,
    disableCloseOnEscKeyAndOutsideClick?: boolean
}

export const Dialog: React.FunctionComponent<DialogProps> = (props) => {

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onClose = () => {
        if (props.onClose) {
            props.onClose();
        }
    }

    const footerActions = (<React.Fragment>
        {(!props.footerActions ? [] : props.footerActions).map((a, i) => React.cloneElement(a, { key: i, ...a.props }))}
    </React.Fragment>);

    return (
        <StyledDialog open={true} onClose={onClose}
            className={`${stylingClassName}`}
            disableBackdropClick={props.disableCloseOnEscKeyAndOutsideClick}
            disableEscapeKeyDown={props.disableCloseOnEscKeyAndOutsideClick}
            theme={{ width: props.width, height: props.height }}>
            {props.title && <MuiDialogTitle>{props.title}</MuiDialogTitle>}
            <MuiDialogContent className={'scroll'}>   
                {props.children}
            </MuiDialogContent>
            {props.footerActions && <MuiDialogActions>{footerActions}</MuiDialogActions>}
        </StyledDialog>
    );
}